import { createContext } from 'react';
import DialogOptions from './Options';

const DialogContext = createContext({
  show(message: string, options?: DialogOptions) {},
});

export default DialogContext;
